import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { Link } from "react-router-dom";
import Dialog from "material-ui/Dialog";
import TextField from "@material-ui/core/TextField";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import { DeviceFraudStatusIcon } from "app/components/AppComponents/Fraud";
import handleMutationError from "app/utils/handleMutationError";
import * as $ from "jquery";

import oktaClient from "app/utils/oktaClient";
const update = require("immutability-helper");

class Summary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      status: null,
      summary: null,
      bankCardElevations: null,
      paymentElevations: null,
      bankCardElevation: {
        comment: "",
        expires_in: "",
        max_count: 0,
        secure_3d: false,
      },
      paymentElevation: {
        comment: "",
        expires_in: "",
        max_count: 0,
        max_amount: "",
        secure_3d: false,
      },
      paymentModal: false,
      bankCardModal: false,
    };

    this.loadData = this.loadData.bind(this);

    // BANK CARD CHANGE HANDLERS
    this.changeBankDetails = this.changeBankDetails.bind(this);
    this.elevateBankCard = this.elevateBankCard.bind(this);

    // PAYMENT CHANGE HANDLERS
    this.changePaymentDetails = this.changePaymentDetails.bind(this);
    this.elevatePayment = this.elevatePayment.bind(this);

    // MODALS
    this.changeModalState = this.changeModalState.bind(this);

    this.changeDeviceStatus = this.changeDeviceStatus.bind(this);
  }

  componentDidMount() {
    this.props.setHeader({
      title: "Ops > Device",
      description: "SnapScan device",
    });
    this.loadData();
  }

  // LOAD DATA
  loadData() {
    this.setState({ bankCardElevations: null, paymentElevations: null });

    this.props.data.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({
          status: fetchMoreResult.devices[0].fraud_status,
          summary: fetchMoreResult.devices[0],
          bankCardElevations:
            fetchMoreResult.devices[0].bank_card_change_privilege_elevation,
          paymentElevations:
            fetchMoreResult.devices[0].payment_privilege_elevation,
        });
      },
    });
  }

  changeDeviceStatus(e: any, key: any, status: any) {
    const thiss = this;
    const token = oktaClient.getToken();
    const comment = "Updated by " + token.claims.email;

    if (this.state.summary) {
      $.ajax({
        type: "POST",
        url:
          process.env["REACT_APP_" + process.env.REACT_APP_ENV + "_LINK"] +
          "/integration/console/fraud/device/fraud_status",
        data: {
          external_reference: this.state.summary.external_reference,
          comment: comment,
          status: status,
        },
        headers: {
          Authorization: "Bearer " + token.idToken,
          "x-User-Groups": "snapscan",
        },
      }).done(function () {
        thiss.loadData();
      });
    }
  }

  // BANK CARD CHANGE HANDLERS
  changeBankDetails(event: any, field: any) {
    if (field === "secure_3d") {
      this.setState(
        update(this.state, {
          bankCardElevation: { [field]: { $set: event.target.checked } },
        })
      );
    } else {
      this.setState(
        update(this.state, {
          bankCardElevation: { [field]: { $set: event.target.value } },
        })
      );
    }
  }
  elevateBankCard() {
    if (
      parseInt(this.state.bankCardElevation.max_count, 10) > 0 &&
      parseInt(this.state.bankCardElevation.expires_in, 10) > 0
    ) {
      this.props
        .elevateBankCard({
          variables: {
            device_external_reference: this.props.match.params.id,
            comment: this.state.bankCardElevation.comment,
            expires_in: Math.ceil(
              parseInt(this.state.bankCardElevation.expires_in, 10) * 60
            ),
            max_count: parseInt(this.state.bankCardElevation.max_count, 10),
            secure3d_required: this.state.bankCardElevation.secure_3d,
          },
        })
        .then(({ data }) => {
          this.setState({
            bankCardElevation: {
              comment: "",
              expires_in: "",
              max_count: 0,
              secure_3d: false,
            },
            bankCardElevations: data.elevate_bank_card_change_privileges,
          });
          this.changeModalState("bankCard");
        })
        .catch(handleMutationError);
    }
  }

  // BANK CARD CHANGE HANDLERS
  changePaymentDetails(event: any, field: any) {
    if (field === "secure_3d") {
      this.setState(
        update(this.state, {
          paymentElevation: { [field]: { $set: event.target.checked } },
        })
      );
    } else {
      this.setState(
        update(this.state, {
          paymentElevation: { [field]: { $set: event.target.value } },
        })
      );
    }
  }

  elevatePayment() {
    if (
      parseInt(this.state.paymentElevation.max_count, 10) > 0 &&
      parseInt(this.state.paymentElevation.expires_in, 10) > 0
    ) {
      this.props
        .elevatePayment({
          variables: {
            device_external_reference: this.props.match.params.id,
            comment: this.state.paymentElevation.comment,
            expires_in: Math.ceil(
              parseInt(this.state.paymentElevation.expires_in, 10) * 60
            ),
            max_count: Math.floor(
              parseInt(this.state.paymentElevation.max_count, 10)
            ),
            max_amount: Math.ceil(
              parseInt(this.state.paymentElevation.max_amount, 10) * 100
            ),
            secure3d_required: this.state.paymentElevation.secure_3d,
          },
        })
        .then(({ data }) => {
          this.setState({
            paymentElevation: {
              comment: "",
              expires_in: "",
              max_count: 0,
              max_amount: "",
              secure_3d: false,
            },
            paymentElevations: data.elevate_payment_privileges,
          });
          this.changeModalState("payment");
        })
        .catch(handleMutationError);
    }
  }

  // MODALS
  changeModalState(modal: any) {
    this.setState({ [`${modal}Modal`]: !this.state[`${modal}Modal`] });
  }

  render() {
    const device = this.state.summary ? this.state.summary : null;

    //  FORMAT DATE
    const formatDate = (date) => {
      let DateObj = new Date(date);
      let formatFullDate = `${DateObj.getFullYear()}-${(
        "0" + (parseInt(DateObj.getMonth().toString(), 10) + 1).toString()
      ).slice(-2)}-${("0" + DateObj.getDate()).slice(-2)} ${(
        "0" + DateObj.getHours()
      ).slice(-2)}:${("0" + DateObj.getMinutes()).slice(-2)}:${(
        "0" + DateObj.getSeconds()
      ).slice(-2)}`;
      return <span>{formatFullDate}</span>;
    };

    //  EXPIRY FORMATING
    const formatExpiry = (status) => {
      if (status) {
        return <span>Expired</span>;
      } else {
        return <span>Active</span>;
      }
    };

    //  SECURE 3D
    const formatSecure3D = (status3D) => {
      if (status3D) {
        return <i className="fa fa-lock fa-lg" style={{ color: "green" }} />;
      } else {
        return <i className="fa fa-minus fa-lg" style={{ color: "red" }} />;
      }
    };

    // Summary
    const Summary = () => {
      if (device) {
        return (
          <tbody>
            <tr>
              <td> {formatDate(device.created_at)} </td>
              <td> {device.first_name} </td>
              <td> {device.surname} </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/users/${device.user.external_reference}/payments`}
                >
                  {device.user.email}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={device.user.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={device.dashboard_url}
                >
                  {device.phone_number}
                </a>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={device.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td style={{ textAlign: "center" }}>
                <DeviceFraudStatusIcon device={device} />
              </td>
            </tr>
          </tbody>
        );
      } else {
        return null;
      }
    };

    // Details
    const Details = () => {
      if (device) {
        return (
          <table
            style={{
              fontSize: "14px",
              paddingTop: "10px",
              width: "100%",
            }}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td colSpan={4}>
                  <h3
                    style={{
                      borderBottom: "1px solid rgb(204, 204, 204)",
                      fontWeight: 400,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ flex: 1 }}>Devices</span>
                    <span style={{ marginRight: "10px" }}>Status: </span>
                    <SelectField
                      hintText="Click to Change"
                      value={null}
                      onChange={this.changeDeviceStatus}
                      style={{
                        alignSelf: "flex-end",
                      }}
                      underlineStyle={{
                        borderWidth: 0,
                      }}
                    >
                      <MenuItem value={"monitored"} primaryText="Monitored" />
                      <MenuItem
                        value={"whitelisted"}
                        primaryText="Whitelisted"
                      />
                      <MenuItem
                        value={"blacklisted"}
                        primaryText="Blacklisted"
                      />
                    </SelectField>
                  </h3>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "5px", paddingLeft: 0 }}>
                  <b style={{ fontWeight: 400 }}>Model:</b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  {device.model} ({device.platform}){" "}
                </td>
                <td style={{ padding: "5px", paddingLeft: "20px" }}>
                  <b style={{ fontWeight: 400 }}>Platform version:</b>
                </td>
                <td style={{ padding: "5px" }}>{device.platform_version}</td>
              </tr>
              <tr>
                <td style={{ padding: "5px", paddingLeft: 0 }}>
                  <b style={{ fontWeight: 400 }}>Phone number:</b>
                </td>
                <td style={{ padding: "5px" }}> {device.phone_number} </td>
                <td style={{ padding: "5px", paddingLeft: "20px" }}>
                  <b style={{ fontWeight: 400 }}>App version:</b>
                </td>
                <td style={{ padding: "5px" }}>{device.app_version}</td>
              </tr>
            </tbody>
          </table>
        );
      } else {
        return null;
      }
    };

    // BANK CARD ELEVATIONS
    const bankCardElevations = () => {
      if (this.state.bankCardElevations) {
        return (
          <tr>
            <td>{formatDate(this.state.bankCardElevations.created_at)}</td>
            <td>{formatExpiry(this.state.bankCardElevations.expired)}</td>
            <td>{formatDate(this.state.bankCardElevations.expires_at)}</td>
            <td>{this.state.bankCardElevations.max_count}</td>
            <td>
              {formatSecure3D(this.state.bankCardElevations.secure3d_required)}
            </td>
          </tr>
        );
      } else {
        return (
          <tr>
            <td colSpan={5} style={{ textAlign: "center" }}>
              {" "}
              No bank card elevations added.{" "}
            </td>
          </tr>
        );
      }
    };

    // PAYMENT ELEVATIONS
    const paymentElevations = () => {
      if (this.state.paymentElevations) {
        return (
          <tr>
            <td>{formatDate(this.state.paymentElevations.created_at)}</td>
            <td>{formatExpiry(this.state.paymentElevations.expired)}</td>
            <td>{formatDate(this.state.paymentElevations.expires_at)}</td>
            <td>{this.state.paymentElevations.max_count}</td>
            <td>
              R
              {(
                parseInt(this.state.paymentElevations.max_amount, 10) / 100
              ).toFixed(2)}
            </td>
            <td>
              {formatSecure3D(this.state.paymentElevations.secure3d_required)}
            </td>
          </tr>
        );
      } else {
        return (
          <tr>
            <td colSpan={6} style={{ textAlign: "center" }}>
              {" "}
              No payment elevations added.{" "}
            </td>
          </tr>
        );
      }
    };

    return (
      <section className="padded scrollable">
        <div>
          <table
            style={{
              fontSize: "14px",
              paddingTop: "10px",
              width: "100%",
            }}
            className="BOTable"
            cellPadding={0}
            cellSpacing={0}
          >
            <thead>
              <tr>
                <th>
                  <b style={{ color: "#555" }}>Date</b>
                </th>
                <th>
                  <b style={{ color: "#555" }}>First name</b>
                </th>
                <th>
                  <b style={{ color: "#555" }}>Surname</b>
                </th>
                <th>
                  <b style={{ color: "#555" }}>User</b>
                </th>
                <th>
                  <b style={{ color: "#555" }}>Device</b>
                </th>
                <th style={{ textAlign: "center" }}>
                  <b style={{ color: "#555" }}>Fraud status</b>
                </th>
              </tr>
            </thead>
            {Summary()}
          </table>
          {Details()}

          <table
            style={{
              fontSize: "14px",
              paddingTop: "10px",
              width: "100%",
            }}
            className="BOTable"
            cellPadding={0}
            cellSpacing={0}
          >
            <thead>
              <tr>
                <td colSpan={5}>
                  <h3
                    style={{
                      borderBottom: "1px solid rgb(204, 204, 204)",
                      paddingBottom: "10px",
                      fontWeight: 400,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ flex: 1 }}>Bank card elevation</span>
                    <input
                      type="button"
                      className="button"
                      value="Add"
                      onClick={() => this.changeModalState("bankCard")}
                    />
                  </h3>
                </td>
              </tr>
              <tr>
                <th>Date</th>
                <th>Status</th>
                <th>Expires in</th>
                <th>Max count</th>
                <th>Secure 3D</th>
              </tr>
            </thead>
            <tbody>{bankCardElevations()}</tbody>
          </table>
          <Dialog
            title="Add Bank Card Elevation"
            modal={false}
            open={this.state.bankCardModal}
            onRequestClose={() => this.changeModalState("bankCard")}
            actions={[
              <input
                type="button"
                className="button"
                value="Add"
                onClick={() => this.elevateBankCard()}
              />,
            ]}
          >
            <table>
              <tbody>
                <tr>
                  <td>
                    <label>Comment</label>
                  </td>
                  <td>
                    <TextField
                      name="cardComment"
                      type="text"
                      value={this.state.bankCardElevation.comment}
                      onChange={(event) =>
                        this.changeBankDetails(event, "comment")
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Expires in</label>
                  </td>
                  <td>
                    <TextField
                      name="cardExpires"
                      type="number"
                      placeholder="Minutes"
                      onChange={(event) =>
                        this.changeBankDetails(event, "expires_in")
                      }
                      value={this.state.bankCardElevation.expires_in}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Max count</label>
                  </td>
                  <td>
                    <TextField
                      name="cardCount"
                      type="number"
                      inputProps={{ min: "1" }}
                      value={this.state.bankCardElevation.max_count}
                      onChange={(event) =>
                        this.changeBankDetails(event, "max_count")
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Secure 3D</label>
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      onChange={(event) =>
                        this.changeBankDetails(event, "secure_3d")
                      }
                      checked={
                        this.state.bankCardElevation.secure_3d ? true : false
                      }
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </Dialog>

          <table
            style={{
              fontSize: "14px",
              paddingTop: "10px",
              width: "100%",
            }}
            className="BOTable"
            cellPadding={0}
            cellSpacing={0}
          >
            <thead>
              <tr>
                <td colSpan={6}>
                  <h3
                    style={{
                      borderBottom: "1px solid rgb(204, 204, 204)",
                      paddingBottom: "10px",
                      fontWeight: 400,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ flex: 1 }}>Payment elevation</span>
                    <input
                      type="button"
                      className="button"
                      value="Add"
                      onClick={() => this.changeModalState("payment")}
                    />
                  </h3>
                </td>
              </tr>
              <tr>
                <th>Date</th>
                <th>Status</th>
                <th>Expires in</th>
                <th>Max count</th>
                <th>Max amount</th>
                <th>Secure 3D</th>
              </tr>
            </thead>
            <tbody>{paymentElevations()}</tbody>
          </table>
          <Dialog
            title="Add Payment Elevation"
            modal={false}
            open={this.state.paymentModal}
            onRequestClose={() => this.changeModalState("payment")}
            actions={[
              <input
                type="button"
                value="Add"
                className="button"
                onClick={() => this.elevatePayment()}
              />,
            ]}
          >
            <table>
              <tbody>
                <tr>
                  <td>
                    <label>Comment</label>
                  </td>
                  <td>
                    <TextField
                      name="payComment"
                      type="text"
                      value={this.state.paymentElevation.comment}
                      onChange={(event) =>
                        this.changePaymentDetails(event, "comment")
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Expires in</label>
                  </td>
                  <td>
                    <TextField
                      name="payExpires"
                      type="number"
                      placeholder="Minutes"
                      onChange={(event) =>
                        this.changePaymentDetails(event, "expires_in")
                      }
                      value={this.state.paymentElevation.expires_in}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Max count</label>
                  </td>
                  <td>
                    <TextField
                      name="payCount"
                      type="number"
                      inputProps={{ min: 1 }}
                      value={this.state.paymentElevation.max_count}
                      onChange={(event) =>
                        this.changePaymentDetails(event, "max_count")
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>
                      Max amount <b>R</b>
                    </label>
                  </td>
                  <td>
                    <TextField
                      name="payAmount"
                      type="text"
                      inputProps={{ min: "1" }}
                      value={this.state.paymentElevation.max_amount}
                      onChange={(event) =>
                        this.changePaymentDetails(event, "max_amount")
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Secure 3D</label>
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      onChange={(event) =>
                        this.changePaymentDetails(event, "secure_3d")
                      }
                      checked={
                        this.state.paymentElevation.secure_3d ? true : false
                      }
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </Dialog>
        </div>
      </section>
    );
  }
}

const deviceStats = gql`
  query deviceStats($external_reference: ID) {
    devices(external_reference: $external_reference) {
      app_version
      build_type
      build_version
      category
      created_at
      dashboard_url
      external_reference
      first_name
      device_only_fraud_status
      model
      name
      phone_number
      platform
      platform_version
      rooted
      snapmin_url
      surname
      token
      touch_id_supported
      user_agent
      user {
        email
        external_reference
        snapmin_url
      }
      bank_card_change_privilege_elevation {
        created_at
        elevation_type
        expired
        expires_at
        max_amount
        max_count
        secure3d_required
        updated_at
      }
      payment_privilege_elevation {
        created_at
        elevation_type
        expired
        expires_at
        max_amount
        max_count
        secure3d_required
        updated_at
      }
    }
  }
`;

const elevateBankCard = gql`
  mutation elevateBankCard(
    $device_external_reference: String!
    $comment: String!
    $expires_in: Int!
    $max_count: Int!
    $secure3d_required: Boolean!
  ) {
    elevate_bank_card_change_privileges(
      device_external_reference: $device_external_reference
      comment: $comment
      expires_in: $expires_in
      max_count: $max_count
      secure3d_required: $secure3d_required
    ) {
      created_at
      elevation_type
      expired
      expires_at
      max_amount
      max_count
      secure3d_required
      updated_at
    }
  }
`;

const elevatePayment = gql`
  mutation elevatePayment(
    $device_external_reference: String!
    $comment: String!
    $expires_in: Int!
    $max_count: Int!
    $max_amount: Int!
    $secure3d_required: Boolean!
  ) {
    elevate_payment_privileges(
      device_external_reference: $device_external_reference
      comment: $comment
      expires_in: $expires_in
      max_count: $max_count
      max_amount: $max_amount
      secure3d_required: $secure3d_required
    ) {
      created_at
      elevation_type
      expired
      expires_at
      max_amount
      max_count
      secure3d_required
      updated_at
    }
  }
`;

const Device = graphql(deviceStats, {
  options(props: any) {
    return {
      variables: {
        external_reference: props.match.params.id,
      },
    };
  },
})(
  graphql(elevatePayment, { name: "elevatePayment" })(
    graphql(elevateBankCard, { name: "elevateBankCard" })(Summary)
  )
);
export default Device;
